/**
 * Daily Reward Modal Component
 * Ported from React Native version
 */
import React, { useState, useEffect } from 'react';
import './DailyRewardModal.css';
import freeDcoinIcon from '../assets/icon/freeDcoin.png';

interface DailyRewardModalProps {
    isVisible: boolean;
    onClaim: () => Promise<void>;
    onClose: () => void;
}

const DailyRewardModal: React.FC<DailyRewardModalProps> = ({ isVisible, onClaim, onClose }) => {
    const [isClaiming, setIsClaiming] = useState(false);
    const [claimed, setClaimed] = useState(false);

    // Reset state when modal opens/closes
    useEffect(() => {
        if (!isVisible) {
            setClaimed(false);
        }
    }, [isVisible]);

    const handleClaim = async () => {
        if (isClaiming || claimed) return;

        setIsClaiming(true);
        try {
            await onClaim();
            setClaimed(true);
            // Auto close after success
            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (error) {
            console.error('Failed to claim reward:', error);
        } finally {
            setIsClaiming(false);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="daily-reward-overlay" onClick={onClose}>
            <div className="daily-reward-modal" onClick={(e) => e.stopPropagation()}>

                {/* Decorative Stars */}
                <div className="stars-decoration">
                    <span className="star star-1">✦</span>
                    <span className="star star-2">✦</span>
                    <span className="star star-3">✦</span>
                    <span className="star star-4">✦</span>
                    <span className="star star-5">✦</span>
                    <span className="star star-6">✦</span>
                </div>

                {/* Title */}
                <h1 className="daily-reward-title">Free 100 DCoin</h1>
                <p className="daily-reward-subtitle">Refreshes Daily At Midnight</p>

                {/* Coin Icon */}
                <div className="coin-container">
                    <img
                        src={freeDcoinIcon}
                        alt="Free DCoin"
                        className={`coin-icon ${claimed ? 'claimed' : ''}`}
                    />
                </div>

                {/* Claim Button */}
                <button
                    className={`claim-button ${isClaiming ? 'claiming' : ''} ${claimed ? 'claimed' : ''}`}
                    onClick={handleClaim}
                    disabled={isClaiming || claimed}
                >
                    {isClaiming ? (
                        <span className="loading-spinner"></span>
                    ) : (
                        <span>{claimed ? '✓ Claimed!' : 'Claim Now'}</span>
                    )}
                </button>
            </div>
        </div>
    );
};

export default DailyRewardModal;
